package app.smartcoding.realrate.localization

import cafe.adriel.lyricist.LyricistStrings

@LyricistStrings(languageTag = "ar", default = false)
val ArStrings = Strings(
    analyzer = "محلل",
    appreciationOverview = "نظرة عامة على التقدير",
    chartLegendInterest = "فائدة",
    chartLegendPrincipal = "رأس المال",
    chartXaxisMonths = "أشهر",
    chartYaxisPayment = "دفعة",
    code = "ar",
    costOfCredit = "تكلفة الائتمان",
    creditDealAnalyzerDescription = "أدخل تفاصيل القرض الخاص بك للحصول على تحليل شامل للصفقة. يقوم محللنا بتقييم المقاييس الرئيسية لمساعدتك على فهم التكلفة الحقيقية لقرضك واتخاذ قرار مستنير.",
    detailsGoodRateLongTerm = "سعر جيد ولكن فترة طويلة تؤدي إلى ارتفاع التكلفة الإجمالية.",
    detailsHighApr = "معدل فائدة سنوي مرتفع. ",
    detailsHighInterestCost = "ارتفاع التكلفة الإجمالية للفائدة.",
    detailsHighRateShortTerm = "سعر مرتفع ولكن فترة قصيرة تبقي التكلفة الإجمالية منخفضة.",
    detailsLowApr = "معدل فائدة سنوي منخفض. ",
    detailsLowInterestCost = "انخفاض التكلفة الإجمالية للفائدة.",
    discountsTradeIn = "خصومات / استبدال",
    displayName = "العربية",
    distribution = "توزيع",
    downPayment = "دفعة أولى",
    effectiveApr = "معدل الفائدة السنوي",
    headerBalance = "الرصيد",
    headerDate = "التاريخ",
    headerInterest = "فائدة",
    headerMonth = "#",
    headerPayment = "دفعة",
    headerPrincipal = "رأس المال",
    hideDetails = "إخفاء التفاصيل",
    interest = "فائدة",
    invalidData = "بيانات غير صالحة",
    loanAmountSupportingText = "إجمالي مبلغ القرض، بما في ذلك أي تكاليف إضافية.",
    loanDetails = "تفاصيل القرض",
    paymentSupportingText = "دفعتك الشهرية المقدرة.",
    paymentComposition = "تركيبة الدفع",
    percentSymbol = "%",
    principal = "رأس المال",
    ratingBad = "صفقة سيئة",
    ratingExcellent = "صفقة ممتازة",
    ratingFair = "صفقة عادلة",
    ratingGood = "صفقة جيدة",
    ratingPoor = "صفقة سيئة",
    schedule = "جدول",
    showDetails = "إظهار التفاصيل",
    summaryBad = "غير مواتية للغاية، تجنبها إذا أمكن.",
    summaryExcellent = "ظروف مالية ممتازة.",
    summaryFair = "ظروف عادلة، فكر في التفاوض.",
    summaryGood = "ظروف جيدة، قياسية في السوق.",
    summaryPoor = "ظروف سيئة، تكلفة أو معدل مرتفع.",
    totalPaid = "إجمالي المدفوع",
    lockTaxRate = "قفل معدل الضريبة",
    unlockTaxRate = "إلغاء قفل معدل الضريبة",
    currencySymbol = "$",
    currency = "عملة",

    totalCreditAmount = "إجمالي مبلغ الائتمان",
    taxAmount = "مبلغ الضريبة",
    netAmountDisbursed = "صافي المبلغ المنصرف", // Изчисляемо поле: totalCreditAmount - всички първоначални такси/данъци

    years = "سنوات",
    loanTermTotalMonths = "إجمالي مدة القرض بالأشهر", // Изчисляемо или входно поле за общия срок

    monthlyInstallment = "القسط الشهري",
    principalInstallment = "قسط رأس المال",
    otherFees = "رسوم أخرى",

    insuranceCost = "تكلفة التأمين",
    aprc = "المعدل السنوي للرسوم (APRC)",
    totalAmountPayable = "إجمالي المبلغ المستحق",
    prepaidFeeFixed = "رسوم مدفوعة مقدمًا ثابتة",
    prepaidFeePercentage = "رسوم مدفوعة مقدمًا كنسبة مئوية",
    months = "أشهر",
    description = "يساعدك هذا المحلل على تقييم ما إذا كان عرض القرض مناسبًا لك. على عكس الآلات الحاسبة القياسية، فإنه لا يتطلب إدخال سعر الفائدة. بدلاً من ذلك، فإنه يحسب معدل الفائدة السنوي والتكلفة الإجمالية للائتمان بناءً على المدفوعات والرسوم، مما يوفر تصنيفًا للصفقة ومخططات تفصيلية.",
    agree = "أوافق",
    information = "معلومات",
    errorDivisionByZero = "القسمة على صفر",
    errorNegativeResult = "نتيجة سلبية",
    errorRateTooHigh = "المعدل مرتفع جدا",
    errorCalculation = "الرجاء إدخال بيانات صحيحة",
    errorCalculationOverflow = "معدل النسبة السنوية الفعلية مرتفع جدًا، تجاوز في الحساب.",
    errorTotalPaymentIsLessThanLoanAmount = "المبلغ المستلم أقل من مبلغ القرض.",

    close = "إغلاق",
    hi = "مرحباً",
    guest = "ضيف",
    account = "الحساب",
    signInWithGoogle = "تسجيل الدخول باستخدام Google",
    signOut = "تسجيل الخروج",
    settings = "الإعدادات",
    about = "حول",
    privacyPolicy = "سياسة الخصوصية",
    termsOfService = "شروط الخدمة",

    language = "اللغة",
    theme = "المظهر",
    light = "فاتح",
    dark = "داكن",
    system = "النظام",
    toggleExpand = "توسيع/طي",
)
